import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEuroOutlinedmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.445 13.243a.632.632 0 0 1-.147.882 4.815 4.815 0 0 1-2.81.901c-2.171 0-4.015-1.446-4.664-3.445h-.881a.632.632 0 0 1 0-1.264h.644c-.007-.105-.016-.21-.016-.317 0-.106.01-.21.016-.316h-.644a.632.632 0 0 1 0-1.264h.88c.65-1.999 2.494-3.445 4.665-3.445 1.011 0 1.983.311 2.81.901a.632.632 0 0 1-.734 1.03 3.559 3.559 0 0 0-2.076-.667c-1.465 0-2.728.896-3.31 2.181H10a.632.632 0 0 1 0 1.265H6.85a4.103 4.103 0 0 0-.015.316c0 .107.007.211.016.316H10a.632.632 0 0 1 0 1.264H7.178c.581 1.286 1.844 2.181 3.31 2.181.746 0 1.465-.23 2.076-.666a.63.63 0 0 1 .881.147ZM19.167 10A9.167 9.167 0 1 1 .833 10a9.167 9.167 0 0 1 18.334 0Zm-1.506 0a7.66 7.66 0 1 0-15.322 0 7.66 7.66 0 0 0 15.322 0Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgEuroOutlinedmin);
export { ForwardRef as ReactComponent };
